import { render, staticRenderFns } from "./BatchImportOrder.vue?vue&type=template&id=0a50ed40&scoped=true"
import script from "./BatchImportOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchImportOrder.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BatchImportOrder.vue?vue&type=style&index=0&id=0a50ed40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a50ed40",
  null
  
)

export default component.exports